import React, { useState, useEffect } from 'react';
import { object } from 'prop-types';
import { withRouter } from 'react-router-dom';
import { withApollo } from 'react-apollo';
import { Main } from 'base-components';
import { get, map, times } from 'lodash';
import { FlexContainer, Loading, Pagination, Row, Text, TableCount } from '../../common';
import { MediaListener } from '../../utils';
import { GET_COMERCIAL_POLICY_REFERENCE } from '../../../queries';
import ComercialPolicyReferenceCard from './ComercialPolicyReferenceCard';
import Header from './Header';
import ModalDelete from './ModalDelete';

const PositionsMaintainerDarkstore = ({ session, client }) => {
    const [comercialPolicyReferences, setComercialPolicyReferences] = useState([]);
    const [loading, setLoading] = useState(false);
    const [itemToRemove, setItemToRemove] = useState(false);
    const [visibleModal, setVisibleModal] = useState(false);
    const [totalRecords, setTotalRecords] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(12);
    const [allData, setAllData] = useState(12);

    const getAllData = async () => {
        const response = await client.query({
            query: GET_COMERCIAL_POLICY_REFERENCE,
            variables: {
                allData: true,
                page: currentPage
            },
            fetchPolicy: 'no-cache'
        });
        setAllData(get(response, 'data.getComercialPolicyReference.payload'));
    };

    useEffect(() => {
        getAllData();
    }, []);

    const getData = async () => {
        const response = await client.query({
            query: GET_COMERCIAL_POLICY_REFERENCE,
            variables: {
                allData: false,
                page: currentPage
            },
            fetchPolicy: 'no-cache'
        });

        const data = get(response, 'data.getComercialPolicyReference.payload');
        setTotalRecords(get(response, 'data.getComercialPolicyReference.totalRecords', 0));
        setComercialPolicyReferences(data);
    };

    const wrapperLoading = async () => {
        setLoading(true);
        await getData();
        setLoading(false);
    };

    useEffect(() => {
        (currentPage !== null) && wrapperLoading();
    }, [currentPage]);

    const getComercialPolicyReferences = async () => {
        setLoading(true);
        await getData();
        setLoading(false);
    };

    useEffect(() => {
        getComercialPolicyReferences();
    }, []);

    const salesChannelOptions = () => {
        return map(allData, ({ title, id, comercial_policy, comercial_policy_reference }) => {
            return { label: `${id} - ${title}`, value: comercial_policy, id, comercial_policy_reference };
        });
    };

    const handleRemoveComercialPolicy = (item) => {
        setItemToRemove(item);
        setVisibleModal(true);
    };

    const Filler = () => {
        return <>
            {times(5, () => <FlexContainer style={{ flex: '1 0 300px' }} height={0} />)}
        </>;
    };

    const refetch = () => getData();

    return (
        <Main background='F4F4F4' withFooter>
            <FlexContainer shrink={0} grow={1} style={{ padding: '5px 25px 0px' }} direction='column'>
                <MediaListener values={['13.55%', '100%', '100%']}>
                    {({ currentValue }) => (<>
                        <Header currentValue={currentValue} session={session} salesChannelOptions={salesChannelOptions()} refetchQuery={refetch} />
                        <Loading loading={loading}>
                            <TableCount count={totalRecords} />
                            <FlexContainer direction='row' style={{ flexWrap: 'wrap', gap: 10 }}>
                                {map(comercialPolicyReferences, (item, index) => {
                                    return (
                                        <ComercialPolicyReferenceCard
                                            key={index}
                                            salesChannelOptions={salesChannelOptions()}
                                            comercialPolicyReference={item}
                                            handleRemoveComercialPolicy={(value) => handleRemoveComercialPolicy(value)}
                                            client={client}
                                            refetchQuery={refetch}
                                        />
                                    );
                                })}
                                <Filler />
                            </FlexContainer>
                            <Row justify='right'>
                                <Pagination
                                    withPageSizeOptions={false}
                                    defaultPageSize={12}
                                    pageSize={pageSize}
                                    onChange={value => setCurrentPage(value)}
                                    current={currentPage}
                                    total={totalRecords}
                                />
                            </Row>
                        </Loading>
                        <ModalDelete
                            itemToRemove={itemToRemove}
                            client={client}
                            visibleModal={visibleModal}
                            setVisibleModal={setVisibleModal}
                            refetchQuery={refetch}
                        />
                    </>)}
                </MediaListener>
            </FlexContainer>
        </Main>
    );
};

PositionsMaintainerDarkstore.propTypes = {
    session: object,
    client: object
};

export default withRouter(withApollo(PositionsMaintainerDarkstore));
